@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.header {
    padding: 0;
}

.mainNavBar {
    padding: 0.5rem 3vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.logo {
    & svg {
        width: 125px;
    }

    @include breakpoint.breakpoint(layout.$belowMedium) {
        & svg {
            width: 75px;
        }
    }
}

.navSection {
    align-items: center;
    display: flex;
    gap: 3vw;

    @include breakpoint.breakpoint(layout.$belowLargeLine) {
        gap: 1.5vw;
    }
}

.accountLink {
    align-items: center;
    color: var(--color-black);
    display: flex;
    gap: 4px;
    justify-content: center;
    text-decoration: none;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        & svg {
            display: none;
        }
    }

    &:hover {
        color: var(--color-cardinal);

        & svg {
            & * {
                fill: var(--color-cardinal);
                stroke: var(--color-cardinal);
            }
        }
    }

    & svg {
        height: 30px;
        width: 30px;

        & * {
            fill: var(--color-black);
            stroke: var(--color-black);
        }
    }

    & span {
        @media (min-width: layout.$mediumLine) and (max-width: layout.$largeLine) {
            display: none;
        }
    }
}
